import { render, staticRenderFns } from "./investigation.vue?vue&type=template&id=b2c48cac"
import script from "./investigation.ts?vue&type=script&lang=js&external"
export * from "./investigation.ts?vue&type=script&lang=js&external"
import style0 from "./investigation.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports